import { AdsAdminRoutes } from './ads_admin_routes';

export const AdminRoutes = [
  ...AdsAdminRoutes,
];



// WEBPACK FOOTER //
// ./node_modules/@reverbdotcom/discovery-ui/src/routes/admin_routes.tsx